import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-88009a1c")

_pushScopeId("data-v-88009a1c")
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "wrapper__left" }
const _hoisted_3 = {
  key: 0,
  class: "wrapper__right"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("a", {
  href: "./#/help-center",
  target: "_blank"
}, [
  /*#__PURE__*/_createVNode("i", { class: "iconfont wrapper__right__icon" }, "")
], -1)
const _hoisted_5 = { class: "wrapper__right__name" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("登录")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_avatar = _resolveComponent("el-avatar")
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", {
        class: "iconfont wrapper__left__fold",
        innerHTML: !_ctx.isCollapse ? '' : '',
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleCollapse && _ctx.handleCollapse(...args)))
      }, null, 8, ["innerHTML"]),
      _createVNode(_component_el_breadcrumb, { separator: "/" }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.routes, (item, index) => {
            return (_openBlock(), _createBlock(_Fragment, {
              key: item.path
            }, [
              (index !== _ctx.routes.length - 1)
                ? (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
                    key: 0,
                    to: { path: item.path }
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : (_openBlock(), _createBlock(_component_el_breadcrumb_item, { key: 1 }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1024))
            ], 64))
          }), 128))
        ]),
        _: 1
      })
    ]),
    (_ctx.user.isLogin)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode(_component_el_tooltip, {
            content: "帮助文档",
            placement: "bottom"
          }, {
            default: _withId(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_el_avatar, {
            style: {"margin-left":"14px"},
            icon: "el-icon-user-solid",
            size: "medium"
          }),
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.user.name), 1)
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode(_component_el_button, { type: "text" }, {
            default: _withId(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]))
  ]))
})